import { Component } from '@angular/core';
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-important-ambulancia',
  standalone: true,
  imports: [
    NgForOf
  ],
  templateUrl: './important-ambulancia.component.html',
  styleUrl: './important-ambulancia.component.css'
})
export class ImportantAmbulanciaComponent {
  listItems = [
    {
      texto: "Asegura atención rápida y eficaz en caso de emergencias.",
    },
    {
      texto: "Reduce el tiempo de respuesta en traslados a centros médicos."
    },
    {
      texto: "Proporciona seguridad y tranquilidad a los colaboradores."
    },
    {
      texto: "Mejora el cumplimiento de normas de seguridad laboral y bienestar."
    }
  ]

}
